/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UnderlineIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABJUlEQVR4nO2TMUuDMRCGMzoLHUV/hVAdXEXM3VmI79Wlq/4Ch07uOle3ggiCi4hFFBfFuT+is4qT4tSSNK3aWr7Ur4NKX7glee7euwsx5l/Kip6SaJsYx1ksMepdVs+TDYhx45OsoJHdDC66rN5PDb7VdEWNv7kiy7iMn+c6oZmrwIrephuInsQJmtksmpE9SzYgQTUksb4752ZHcf7OM5HdSzYQKS/Gsdsk2B/ZPetBj7OlzeVkg5AsetdPZtSYsdC7Y8YciR71m2B9MONqrbQ1b0VbH5OENbyQ4PnLmWjLs+YnWnWuEDplvH0uGs1ereDQMyavViqVGWYsEemGj3UpF/3ZWEWsYMcydicRJLo9ZDC4grxhhiZgfZpUcct4zPUmv0od4ZM2ill0dgkAAAAASUVORK5CYII=)
 */
export const UnderlineIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7.03 16.6c1.18 1.17 2.84 1.76 4.97 1.76s3.79-.59 4.97-1.76c1.2-1.18 1.79-3 1.79-5.46V2.5a.5.5 0 0 0-.5-.5H16.8a.5.5 0 0 0-.5.5v8.77c0 1.63-.38 2.84-1.14 3.64A4.1 4.1 0 0 1 12 16.1c-1.35 0-2.4-.4-3.17-1.2-.75-.8-1.12-2.01-1.12-3.64V2.5a.5.5 0 0 0-.5-.5H5.77a.5.5 0 0 0-.5.5v8.64c0 2.46.59 4.28 1.76 5.46ZM2.5 19.5a.5.5 0 0 0-.5.5v1.5c0 .28.22.5.5.5h19a.5.5 0 0 0 .5-.5V20a.5.5 0 0 0-.5-.5h-19Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
